import React from "react";
import { Link } from "react-router-dom";
import NoPhoto from "../assets/No_Image_Available.jpg";
import {
  FaMapMarkerAlt,
  FaBuilding,
  FaStar,
  FaInfoCircle,
  FaExternalLinkAlt,
} from "react-icons/fa";

function BuildingListItem({ building }) {
  return (
    <div className="bg-white border border-gray-100 rounded-lg shadow-sm hover:shadow-md transition-all duration-300 overflow-hidden">
      <Link
        to={`/building/${building.id}`}
        className="flex flex-col md:flex-row"
      >
        {/* Image column - hidden on mobile */}
        <div className="w-full md:w-48 h-48 md:h-auto flex-shrink-0">
          <img
            className="w-full h-full object-cover"
            src={building?.primaryPhotoUrl || NoPhoto}
            alt={building.buildingName}
          />
        </div>

        {/* Content column */}
        <div className="flex-1 p-5 flex flex-col justify-between">
          <div>
            {/* Building header with name and badges */}
            <div className="flex items-start justify-between mb-2">
              <div className="flex items-start">
                <FaBuilding className="text-[#ff5003] mt-1 mr-2 flex-shrink-0" />
                <h3 className="font-semibold text-gray-800 text-lg">
                  {building.buildingName}
                </h3>
              </div>

              {building.exclusive === "Yes" && (
                <div className="flex items-center gap-1 bg-[#ff5003] px-2 py-1 rounded-full">
                  <FaStar className="text-white text-xs" />
                  <span className="font-medium text-white text-xs">
                    Exclusive
                  </span>
                </div>
              )}
            </div>

            {/* Building address */}
            <div className="flex items-center gap-2 text-gray-600 mb-3">
              <FaMapMarkerAlt className="text-gray-400 flex-shrink-0" />
              <p className="text-sm">{building.address}</p>
            </div>

            {/* Extra info */}
            <div className="grid grid-cols-2 gap-4 mb-4">
              {building.businessDistrict && (
                <div className="flex flex-col">
                  <span className="text-xs text-gray-500">
                    Business District
                  </span>
                  <span className="text-sm font-medium">
                    {building.businessDistrict}
                  </span>
                </div>
              )}

              {building.developer && (
                <div className="flex flex-col">
                  <span className="text-xs text-gray-500">Developer</span>
                  <span className="text-sm font-medium">
                    {building.developer}
                  </span>
                </div>
              )}

              {building.yearConstructed && (
                <div className="flex flex-col">
                  <span className="text-xs text-gray-500">Year Built</span>
                  <span className="text-sm font-medium">
                    {building.yearConstructed}
                  </span>
                </div>
              )}

              {building.certifications && (
                <div className="flex flex-col">
                  <span className="text-xs text-gray-500">Certifications</span>
                  <span className="text-sm font-medium">
                    {building.certifications}
                  </span>
                </div>
              )}
            </div>
          </div>

          {/* Action buttons */}
          <div className="flex items-center justify-end gap-2 mt-2">
            <div className="text-xs px-2 py-1 bg-gray-100 text-gray-600 rounded-md">
              {building.city || "City"}
            </div>

            <button className="flex items-center gap-1 bg-white border border-[#002368] text-[#002368] px-3 py-1.5 rounded-lg text-sm font-medium hover:bg-[#002368] hover:text-white transition-colors duration-200">
              <FaInfoCircle size={14} /> Details
            </button>

            {building.googleMapsPin && (
              <a
                href={building.googleMapsPin}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-1 bg-[#002368] text-white px-3 py-1.5 rounded-lg text-sm font-medium hover:bg-[#ff5003] transition-colors duration-200"
              >
                <FaExternalLinkAlt size={12} /> Maps
              </a>
            )}
          </div>
        </div>
      </Link>
    </div>
  );
}

export default BuildingListItem;
